
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/payment-initiation/virtual-accounts/payment-confirmation",
      function () {
        return require("private-next-pages/docs/payment-initiation/virtual-accounts/payment-confirmation.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/payment-initiation/virtual-accounts/payment-confirmation"])
      });
    }
  